// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as AdjustFareApiModel from "./AdjustFareApiModel.bs.js";

function data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var popup_message = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "popup_message"), null));
  if (popup_message.TAG === /* Ok */0) {
    var order_fare = AdjustFareApiModel.order_fare_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_fare"), null));
    if (order_fare.TAG === /* Ok */0) {
      var new_customer_fare_without_prev_dues = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "new_customer_fare_without_prev_dues"), null));
      if (new_customer_fare_without_prev_dues.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  popup_message: popup_message._0,
                  order_fare: order_fare._0,
                  new_customer_fare_without_prev_dues: new_customer_fare_without_prev_dues._0
                }
              };
      }
      var e = new_customer_fare_without_prev_dues._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".new_customer_fare_without_prev_dues" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = order_fare._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".order_fare" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = popup_message._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".popup_message" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = data_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  data_decode ,
  t_decode ,
  
}
/* No side effect */
